import { render, staticRenderFns } from "./UsageBill.vue?vue&type=template&id=a24f3ea6&scoped=true&"
import script from "./UsageBill.vue?vue&type=script&lang=ts&"
export * from "./UsageBill.vue?vue&type=script&lang=ts&"
import style0 from "./UsageBill.vue?vue&type=style&index=0&id=a24f3ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24f3ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VCard,VContainer,VIcon})
